export const fieldUniforms = `
uniform vec2 iResolution;uniform vec2 iMouse;uniform float iTime;
uniform vec3 color;uniform vec3 color2;uniform vec3 backgroundColor;
uniform float intensity;uniform float seed;
float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7))+seed*.17)*43758.5453);}
float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1,0)),f.x),mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),f.x),f.y);}
`;
